<script lang="ts">
  import { Alert, type ComponentTypeProps } from "@tastyworks/ui-library"
  import { toast } from "@zerodevx/svelte-toast"

  type AlertRootProps = ComponentTypeProps<typeof Alert.Root>

  interface Props {
    title: string
    description: string
    descriptionItems?: string[]
    variant: AlertRootProps["variant"]
    toastId: number
  }

  let {
    title,
    description,
    descriptionItems = [],
    variant,
    toastId,
  }: Props = $props()
</script>

<Alert.Root
  {variant}
  dismissible
  ondismiss={() => toast.pop(toastId)}
  data-testid="toast-alert"
>
  <Alert.Title>
    {title}
  </Alert.Title>

  <Alert.Description>
    {description}
    {#if descriptionItems.length > 0}
      <ul class="mt-1">
        {#each descriptionItems as item}
          <li class="list-['-_']">{item}</li>
        {/each}
      </ul>
    {/if}
  </Alert.Description>
</Alert.Root>

<style>
  :global(._toastContainer) {
    /* this will isolate toasts during view-transitions */
    view-transition-name: toast-container;
  }
</style>
